<template>
  <div style="width: 100%;background-color: white">
    <div class="title-name">
      <div style="display: flex;align-items: center">
        <img src="@/assets/image/home/navBar.png">
      </div>
      <el-menu :default-active="activeIndex"  mode="horizontal" @select="handleSelect" router>
<!--        <el-menu-item style="width: 23%">-->
        <el-menu-item index="/">首 页</el-menu-item>
        <el-submenu index="1" style="width: 15%" @click.native="handleSelect('/about')" :popper-append-to-body="false" popper-class="centered">
          <template  slot="title">关于我们</template>
          <el-menu-item index="/about">公司概况</el-menu-item>
          <el-menu-item index="/serviceField" >服务领域</el-menu-item>
          <el-menu-item index="/members" >成员单位</el-menu-item>
        </el-submenu>
        <el-menu-item index="/tendering">招标信息</el-menu-item>
        <el-menu-item index="/culture">企业文化</el-menu-item>
        <el-menu-item index="/PartyBuilding">党建活动</el-menu-item>
        <el-menu-item index="/recruit">人才招聘</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
// import Select from '@/components/Select'

export default {
  // components: { Select },
  data() {
    return {
      activeIndex:undefined,
    }
  },
  created: function () {
  },
  methods: {
    handleSelect(index){
        this.activeIndex=index
      if(index!='/'){
        this.$store.commit('SET_SHOW_BOTTOM',true)
      }

        this.$router.push(index)
    },
  }
}
</script>

<style scoped>
.top{
  margin-top: 10px;
  width: 100%;
  height: 60px;
  background-color: #234C9C;
}
.centered {
  text-align: center;
  font-weight: 400;
}
.el-menu .el-menu--popup {
  width: 20px;
}

.el-menu {
  font-size: 24px;
  font-weight: bold;
  top: 0;
  width: 100%;
  position: static;
  font-family: Regular;
}
::v-deep .el-menu--popup{
  min-width: 40px !important;
  width: 100%;
}
.el-menu-item{
  width: 13%;
}

.title-name {
  text-align: center;
  display: flex;
  justify-content: center;
  position: relative;
}
</style>
